import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

const styles = {
  buttonGroup: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  button: {
    flex: 1,
    flexBasis: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 73,
    padding: "8px 16px",
    transition: "all 300ms",
    cursor: "pointer",
    borderBottom: "2px solid #fff"
  },
  buttonActive: {
    flex: 1,
    flexBasis: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 73,
    padding: "8px 16px",
    cursor: "pointer",
    borderBottom: "2px solid #009be8",
    backgroundColor: "#f4f7fa"
  },
  buttonDisabled: {
    flex: 1,
    flexBasis: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 73,
    padding: "8px 16px",
    color: "#CCC",
    borderBottom: "2px solid #fff"
  },
  buttonPrimaryText: {
    textAlign: "center",
    margin: 0
  },
  buttonSecondaryText: {
    textAlign: "center",
    margin: 0
  }
};

class Button extends Component {
  static propTypes = {
    primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    secondaryText: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func
  };

  state = {
    hover: false
  };

  render() {
    const { disabled, primaryText, secondaryText, active } = this.props;
    const attrs = disabled
      ? {
          style: styles.buttonDisabled
        }
      : active
      ? {
          style: styles.buttonActive
        }
      : {
          onClick: this._onClick,
          onMouseEnter: this._toggleHover,
          onMouseLeave: this._toggleHover,
          style: this.state.hover ? styles.buttonActive : styles.button
        };
    return (
      <div {...attrs}>
        <div>
          {primaryText && <h2 style={styles.buttonPrimaryText}>{primaryText}</h2>}
          {secondaryText && <p style={styles.buttonSecondaryText}>{secondaryText}</p>}
        </div>
      </div>
    );
  }

  _onClick = () => {
    this.setState(
      {
        hover: false
      },
      this.props.onClick
    );
  };

  _toggleHover = () => {
    this.setState({
      hover: !this.state.hover
    });
  };
}

const ButtonGroup = props => (
  <div style={styles.buttonGroup}>
    {props.items.map((item, i) => {
      const { path, query, primaryText, secondaryText, active, disabled } = item;
      const onClick = () =>
        props.router.push({
          pathname: path,
          query: query
        });
      return <Button primaryText={primaryText} secondaryText={secondaryText} active={active} onClick={onClick} disabled={disabled} key={i} />;
    })}
  </div>
);

ButtonGroup.propTypes = {
  items: PropTypes.array
};

ButtonGroup.defaultProps = {
  items: []
};

export default withRouter(ButtonGroup);
